import liveLogo from "./live-logo.webp";
import devLogo from "./dev-logo.webp";

// Single source of truth for the brand logo.
//   dev mode (.env.dev / Sunsolv)        -> dev-logo.webp
//   anything else (.env.production etc.) -> live-logo.webp
//
// VITE_APP_ENV comes from the mode env file; MODE is the fallback so a build run
// without that variable still resolves. Unknown values stay on the live logo.
// Vite inlines import.meta.env at build time, so this folds to one asset.
const appEnv = import.meta.env.VITE_APP_ENV || import.meta.env.MODE;

export const IS_DEV_ENV = appEnv === "dev";

const AppLogo = IS_DEV_ENV ? devLogo : liveLogo;

export default AppLogo;
